import _find from "lodash/find";
import httpConfig from "@/mx-configs/mx.http.config";

function findApi(name) {
  return _find(httpConfig.apis, ["name", name]);
}

function getApiConfig() {
  return httpConfig[process.env.MX_ENV];
}

export { findApi, getApiConfig };
